import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const profileIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M64 8v48a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8M47.685 42.837c-6.114-1.41-11.805-2.648-9.05-7.853C47.024 19.139 40.859 10.667 32 10.667c-9.035 0-15.048 8.797-6.635 24.317 2.838 5.235-3.066 6.472-9.05 7.853-5.462 1.262-5.664 3.974-5.648 8.718l.01 1.778h42.648l.008-1.722c.019-4.779-.165-7.507-5.648-8.774"/></svg>`
);
